import { styled } from "@mui/system";
import COLORS from "../../../theme/Colors";
import WarningIcon from "@mui/icons-material/Warning";
import { boxShadowConfig } from "../../../theme/Styles";
import FONTS_FAMILY from "../../../theme/FontsFamily";

export const Container = styled("div")({
    display: "flex",
    flexDirection: "column",
    backgroundColor: COLORS.white,
    width: "100%",
    boxShadow: "none",
    borderRadius: "16px",
    overflow: "hidden",
    border: "1px solid #E1E9EC",
    transition: "transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "none",
        borderColor: "#CFDCE0",
    },
    "html.dark &": {
        backgroundColor: "#000000 !important",
        borderColor: "#222222 !important",
        boxShadow: "none",
    }
});

export const ActionRequiredContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    backgroundColor: COLORS.white,
    width: "100%",
    boxShadow: "none",
    borderRadius: "16px",
    overflow: "hidden",
    border: "1.5px solid #FDBA74 !important",
    transition: "transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "none",
    },
    "html.dark &": {
        backgroundColor: "#000000 !important",
        borderColor: "#FDBA74 !important",
        boxShadow: "none",
    }
});

export const ActionRequiredWarning = styled("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    padding: "10px 24px",
    backgroundColor: "#FFF7ED",
    borderBottom: "1px solid #FFEDD5",
    color: "#C2410C",
    "@media (max-width: 768px)": {
        padding: "10px 16px",
    }
});

export const CardContent = styled("div")({
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    width: "100%",
    boxSizing: "border-box",
    "@media (max-width: 1024px)": {
        padding: "20px",
        gap: "16px",
    },
    "@media (max-width: 768px)": {
        padding: "16px",
        gap: "16px",
    }
});

export const CardBody = styled("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "24px",
    width: "100%",
    "@media (max-width: 1024px)": {
        gap: "16px",
    },
    "@media (max-width: 768px)": {
        flexDirection: "column",
        alignItems: "stretch",
        gap: "16px",
    }
});

export const MetaGrid = styled("div")({
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "12px 24px",
    flex: 1,
    width: "100%",
    "@media (max-width: 1024px)": {
        gap: "10px 16px",
    },
    "@media (max-width: 768px)": {
        gridTemplateColumns: "1fr",
        gap: "6px",
    }
});

export const RowContainer = styled("div")({
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
});

export const ColumnContainer = styled("div")({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
});

export const ColumnContainerRequest = styled("div")({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
});

export const ActionRequiredTitle = styled("p")({
    margin: 0,
    color: "#9A3412",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "700",
    fontSize: "13.5px",
    "@media (min-width:320px)": {
        fontSize: "12px",
    },
    "@media (min-width:768px)": {
        fontSize: "13.5px",
    },
});

export const Title = styled("h2")({
    margin: 0,
    color: "#0F2350",
    fontFamily: "Merriweather, Georgia, serif",
    fontWeight: "700",
    cursor: "pointer",
    transition: "color 0.2s ease",
    "&:hover": {
        color: "#EA361A",
        textDecoration: "underline"
    },
    "@media (min-width:320px)": {
        fontSize: "16px",
    },
    "@media (min-width:768px)": {
        fontSize: "18px",
    },
    "@media (min-width:1200px)": {
        fontSize: "20px",
    },
    "html.dark &": {
        color: "#ffffff !important",
    }
});

export const SubTitle = styled("div")({
    display: "inline-flex",
    alignItems: "center",
    fontSize: "13px",
    fontWeight: "600",
    color: "#64748B",
    fontFamily: "Roboto, sans-serif",
    marginTop: "4px",
    cursor: "pointer",
    transition: "color 0.2s ease",
    "&:hover": {
        color: "#192873",
        textDecoration: "underline"
    },
    "html.dark &": {
        color: "#94a3b8 !important",
    }
});

export const ActionRequiredMessageBox = styled("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "12px",
    backgroundColor: "#FFF7ED",
    padding: "12px 16px",
    borderRadius: "10px",
    border: "1px solid #FFEDD5",
    color: "#9A3412",
    width: "100%",
    boxSizing: "border-box",
    "html.dark &": {
        backgroundColor: "#1e1b4b !important",
        borderColor: "#312e81 !important",
        color: "#fed7aa !important",
    }
});

export const IconContainer = styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});

export const ButtonContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "200px",
    flexShrink: 0,
    "@media (max-width: 1024px)": {
        width: "180px",
    },
    "@media (max-width: 768px)": {
        width: "100%",
    },
});

export const StyledWarningIcon = styled(WarningIcon)((props) => ({
    color: "#EA361A",
    fontSize: "20px"
}));

export const ProgressBarContainer = styled("div")({
    width: "100%",
    backgroundColor: "#F0F4FF",
    borderRadius: "6px",
    height: "8px",
    overflow: "hidden",
    position: "relative",
    "html.dark &": {
        backgroundColor: "#1e293b !important",
    }
});

export const ProgressBarPercent = styled("div")((props) => {
    let barColor = "#2563EB"; // Azul moderno (En proceso)
    if (props.variant === "success") barColor = "#10B981"; // Verde Esmeralda (Completada / Aprobada)
    else if (props.variant === "rejected") barColor = "#EF4444"; // Rojo Alerta (Cancelada / Rechazada)
    else if (props.variant === "warning") barColor = "#F59E0B"; // Naranja Ambar (Acción Requerida)
    else if (props.variant === "payment") barColor = "#8B5CF6"; // Violeta (Esperando Pago)

    return {
        width: props.percent ? props.percent : "25%",
        borderRadius: "6px",
        backgroundColor: barColor,
        height: "8px",
        transition: "width 0.4s ease",
    };
});

export const ProgressHeader = styled("div")({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "6px",
    width: "100%",
});

export const ProgressStatusText = styled("span")({
    fontFamily: "Roboto, sans-serif",
    fontSize: "12px",
    fontWeight: "700",
    color: "#57697F",
    letterSpacing: "0.05em",
    "html.dark &": {
        color: "#cbd5e1 !important",
    }
});

export const ProgressPercentText = styled("span")({
    fontFamily: "Roboto, sans-serif",
    fontSize: "12px",
    fontWeight: "700",
    color: "#0F2350",
    "html.dark &": {
        color: "#38bdf8 !important",
    }
});

export const SolutionAlert = styled("div")({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    backgroundColor: "#fffbeb",
    padding: "12px 16px",
    borderRadius: "8px",
    border: "1px solid #fef3c7",
    color: "#b45309",
    width: "100%",
    boxSizing: "border-box",
    "html.dark &": {
        backgroundColor: "#1e1b4b",
        border: "1px solid #312e81",
        color: "#fef3c7",
    }
});

export const SolutionText = styled("span")({
    fontFamily: FONTS_FAMILY.regular.body,
    fontSize: "14px",
    fontWeight: "500",
    color: "#b45309",
    "html.dark &": {
        color: "#fef3c7 !important",
    }
});

export const DesktopOnlyMeta = styled("div")({
    display: "contents",
    "@media (max-width: 768px)": {
        display: "none !important",
    }
});

export const ProgressContainer = styled("div")({
    marginTop: "8px",
    "@media (max-width: 768px)": {
        display: "none !important",
    }
});

export const ProgressBarTitle = styled("div")({
    display: "none"
});
